var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1275,
    height: 1061,
    viewBox: "0 0 1275 1061",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.138 804.816V626.216H272.291V768.996C272.291 791.321 289.351 809.554 310.148 809.554H1067.5C1088.3 809.554 1105.36 791.335 1105.36 768.996V282.292C1105.36 259.908 1088.3 241.689 1067.5 241.689H634.21V200.085H1123C1146.88 200.085 1166.5 220.939 1166.5 246.59V525.776V804.816V851.32L1275 990.891C1275 1029.45 1245.85 1060.74 1209.92 1060.74H167.787C131.853 1060.74 102.705 1029.45 102.705 990.891L211.207 851.32V804.816H211.138ZM601.903 1037.4H775.637C781.681 1037.4 786.503 1032.23 786.503 1025.75C786.503 1019.28 781.681 1014.11 775.637 1014.11H601.958C596.01 1014.11 591.093 1019.28 591.093 1025.75C591.189 1032.23 595.955 1037.4 601.903 1037.4ZM867.807 990.891L834.675 948.287H542.961L509.83 990.891H867.807Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M669.402 543.26H760.102V640.33H669.402V543.26Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M612.631 409.81H703.275V506.983H612.631V409.81Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M523.456 531.677H614.1V628.792H523.456V531.677Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M434.459 370.297H542.027V485.541H434.459V370.297Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.318 17.0564H389.886V132.301H282.318V17.0564Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M477.481 225.471H585.049V340.716H477.481V225.471Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M262.36 176.171H415.984V340.76H262.36V176.171Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000259399 0H230.904V247.384H-0.000259399V0Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M336.15 498.757H443.718V614.002H336.15V498.757Z",
    fill: "#BBBBBB",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.d1ff8ee0df68207294851e811959749d.svg";
export { ForwardRef as ReactComponent };